import * as React from 'react';
import { createSvgIcon } from "..";

export const SortableArrows = createSvgIcon(
  <path fill="currentColor" d="M8 13L4 9h8zM8 3l4 4H4z" />,
  'small',
);
